import React from "react";
import { trans } from "../../../localization/language";

class MobileOtpNoAccDialog extends React.Component {
  static defaultProps = {
    options: [],
  };

  handleClose = () => {
    const { onClose } = this.props;
    onClose && onClose();
  };

  handleConfirm = () => {
    const { options, onConfirm } = this.props;
    onConfirm && onConfirm(options[0]);
  };

  handleSwitch = () => {
    const { onSwitch } = this.props;
    onSwitch && onSwitch();
  };

  render() {
    const { options } = this.props;

    let button;
    if (options.length > 1) {
      button = (
        <button
          className="verify-mobile-modal__btn primary"
          onClick={this.handleSwitch}
        >
          {trans("register_link_mobile_btn_other_methods")}
        </button>
      );
    } else if (options.length === 1) {
      button = (
        <button
          className="verify-mobile-modal__btn primary"
          onClick={this.handleConfirm}
        >
          {trans("register_link_mobile_btn_send", {
            gateway: trans(options[0]),
          })}
        </button>
      );
    }

    return (
      <div className="verify-mobile-modal no-acc">
        <div className="verify-mobile-modal__dialog">
          <div className="verify-mobile-modal__header">
            {trans("register_link_mobile_notice")}
          </div>

          <div className="verify-mobile-modal__msg">
            {trans("register_link_mobile_no_acc", {
              gateway: trans(this.props.gateway),
            })}
          </div>

          <div className="verify-mobile-modal__actions">
            <button
              className="verify-mobile-modal__btn secondary"
              onClick={this.handleClose}
            >
              {trans("register_link_mobile_btn_ok")}
            </button>
            {button}
          </div>
        </div>
      </div>
    );
  }
}

export default MobileOtpNoAccDialog;



// WEBPACK FOOTER //
// ./app/components/security/verification/MobileOtpNoAccDialog.js